/**
 * DialogFooter Component
 * Reusable footer for deployment dialogs with Back/Cancel/Next|Deploy buttons
 */

import React from 'react';
import { Button } from '@fluentui/react-components';
import './ruleSelection.css';

interface DialogFooterProps {
  /** Show Back button */
  showBack?: boolean;
  /** Back button click handler */
  onBack?: () => void;
  /** Cancel button click handler */
  onCancel: () => void;
  /** Primary action click handler */
  onPrimary: () => void;
  /** Primary button label */
  primaryLabel: string;
  /** Disable the primary button */
  primaryDisabled?: boolean;
  /** Optional content to render before the buttons (e.g., error message) */
  children?: React.ReactNode;
}

/**
 * Renders a dialog footer with optional Back, Cancel, and primary action buttons
 */
export const DialogFooter: React.FC<DialogFooterProps> = ({
  showBack = false,
  onBack,
  onCancel,
  onPrimary,
  primaryLabel,
  primaryDisabled = false,
  children,
}) => {
  return (
    <div className="rsp-footer">
      {showBack && onBack ? (
        <Button appearance="secondary" onClick={onBack}>Back</Button>
      ) : (
        <div /> // Spacer for alignment
      )}
      <div style={{ flex: 1 }}>{children}</div>
      <div style={{ display: 'flex', gap: 8 }}>
        <Button appearance="secondary" onClick={onCancel}>Cancel</Button>
        <Button appearance="primary" disabled={primaryDisabled} onClick={onPrimary}>
          {primaryLabel}
        </Button>
      </div>
    </div>
  );
};

export default DialogFooter;
